"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const org_transcrypt___runtime___js_1 = require("./org.transcrypt.__runtime__.js");
const jsarray = __importStar(require("./tfchain.polyfill.array.js"));
var __name__ = 'tfchain.polyfill.encoding.bin';
exports.from_int8 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0xff),
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.from_int16 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x00ff),
        (num & 0xff00) >> 8,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.to_int16 = function (bs, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'bs':
                        var bs = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var __left0__ = org_transcrypt___runtime___js_1.tuple([bs[0], bs[1]]);
    var f = __left0__[0];
    var s = __left0__[1];
    if (order == 'big') {
        var __left0__ = org_transcrypt___runtime___js_1.tuple([bs[1], bs[0]]);
        var f = __left0__[0];
        var s = __left0__[1];
    }
    var x = 0;
    x = f | (s << 8);
    return org_transcrypt___runtime___js_1.int(x);
};
exports.from_int24 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x0000ff),
        (num & 0x00ff00) >> 8,
        (num & 0xff0000) >> 16,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.to_int24 = function (bs, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'bs':
                        var bs = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var __left0__ = org_transcrypt___runtime___js_1.tuple([bs[0], bs[1], bs[2]]);
    var f = __left0__[0];
    var m = __left0__[1];
    var l = __left0__[2];
    if (order == 'big') {
        var __left0__ = org_transcrypt___runtime___js_1.tuple([bs[2], bs[1], bs[0]]);
        var f = __left0__[0];
        var m = __left0__[1];
        var l = __left0__[2];
    }
    var x = 0;
    x = f | (m << 8) | (l << 16);
    return org_transcrypt___runtime___js_1.int(x);
};
exports.from_int32 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x000000ff),
        (num & 0x0000ff00) >> 8,
        (num & 0x00ff0000) >> 16,
        (num & 0xff000000) >> 24,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.from_int40 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x00000000ff),
        (num & 0x000000ff00) >> 8,
        (num & 0x0000ff0000) >> 16,
        (num & 0x00ff000000) >> 24,
        (num & 0xff00000000) >> 32,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.from_int48 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x0000000000ff),
        (num & 0x00000000ff00) >> 8,
        (num & 0x000000ff0000) >> 16,
        (num & 0x0000ff000000) >> 24,
        (num & 0x00ff00000000) >> 32,
        (num & 0xff0000000000) >> 40,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.from_int56 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x000000000000ff),
        (num & 0x0000000000ff00) >> 8,
        (num & 0x00000000ff0000) >> 16,
        (num & 0x000000ff000000) >> 24,
        (num & 0x0000ff00000000) >> 32,
        (num & 0x00ff0000000000) >> 40,
        (num & 0xff000000000000) >> 48,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.from_int64 = function (num, order) {
    if (typeof order == 'undefined' || (order != null && order.hasOwnProperty("__kwargtrans__"))) {
        ;
        var order = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'num':
                        var num = __allkwargs0__[__attrib0__];
                        break;
                    case 'order':
                        var order = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var buf = null;
    buf = [
        (num & 0x00000000000000ff),
        (num & 0x000000000000ff00) >> 8,
        (num & 0x0000000000ff0000) >> 16,
        (num & 0x00000000ff000000) >> 24,
        (num & 0x000000ff00000000) >> 32,
        (num & 0x0000ff0000000000) >> 40,
        (num & 0x00ff000000000000) >> 48,
        (num & 0xff00000000000000) >> 56,
    ];
    if (order == 'big') {
        return org_transcrypt___runtime___js_1.bytes(jsarray.reverse(buf));
    }
    return org_transcrypt___runtime___js_1.bytes(buf);
};
exports.bin_str_to_int = function (s) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 's':
                        var s = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var x = 0;
    x = parseInt(s, 2);
    var x = org_transcrypt___runtime___js_1.int(x);
    return x;
};
//# sourceMappingURL=tfchain.polyfill.encoding.bin.map
//# sourceMappingURL=tfchain.polyfill.encoding.bin.js.map